import { render, staticRenderFns } from "./PetOwnerForgetPasswordRecovery.vue?vue&type=template&id=f55051ea&scoped=true&"
import script from "./PetOwnerForgetPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./PetOwnerForgetPasswordRecovery.vue?vue&type=script&lang=js&"
import style0 from "./PetOwnerForgetPasswordRecovery.vue?vue&type=style&index=0&id=f55051ea&prod&lang=scss&scoped=true&"
import style1 from "./PetOwnerForgetPasswordRecovery.vue?vue&type=style&index=1&id=f55051ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55051ea",
  null
  
)

export default component.exports